import { Portal } from '@finviz/website'

import { useKnowledgeBase } from './context'

const staticEl = document.getElementById('js-knowledge-base-static')
const rootEl = document.getElementById('js-knowledge-base-root')

interface NavigationButtonTriggerProps {
  /**
   * The route which opens when user clicks the button
   */
  initialRoute?: string
}

export function NavigationButtonTrigger({ initialRoute }: NavigationButtonTriggerProps) {
  const openKnowledgeBase = useKnowledgeBase()

  return (
    <Portal staticElement={staticEl} rootElement={rootEl}>
      <>
        <a
          href="/help/screener.ashx"
          className="is-help"
          onClick={(ev) => {
            if (ev.metaKey) return
            else ev.preventDefault()

            openKnowledgeBase(initialRoute)
          }}
        >
          <span className="fa fa-question-circle"></span> Help
        </a>
      </>
    </Portal>
  )
}
